import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Input,
	Output,
	ViewEncapsulation,
} from "@angular/core";
import { CovidMeasuresConfigService } from "@obg/ngx.core";

import { SgaLoginMessages } from "../../login-ui/login-ui.model";

@Component({
	selector: "obg-m-sga-login-notice",
	templateUrl: "./sga-login-notice.component.html",
	styleUrls: ["./sga-login-notice.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class SgaLoginNoticeComponent {
	@HostBinding("class.obg-m-sga-login-notice") hostCssClass = true;
	@Input() data: SgaLoginMessages | undefined;
	@Output() anchorClick = new EventEmitter();
	covidMeasuresEnabled = this.measuresConfig.covidMeasuresEnabled();

	constructor(private measuresConfig: CovidMeasuresConfigService) {}

	closeOnClickAnchor(nodeName: string) {
		if (nodeName === "A") {
			this.anchorClick.emit();
		}
	}
}
